import api from '../config/api';
import { API_URLS } from '../config/urls';

export const propertyService = {
    searchProperties: async (queryParams = {}) => {
        try {
            // Converts query object to query string natively via axios params
            const response = await api.get(API_URLS.PROPERTIES_SEARCH, { params: queryParams });
            return response.data;
        } catch (error) {
            console.error('Error fetching property search results:', error);
            throw error;
        }
    },
    getPropertyDetail: async (id) => {
        try {
            const response = await api.get(API_URLS.PROPERTY_DETAIL(id));
            return response.data;
        } catch (error) {
            console.error(`Error fetching detail for property ${id}:`, error);
            throw error;
        }
    },

    // Clean Hotel & Global Inventory Methods (No ratehawk prefix)
    searchHotels: async (queryParams = {}) => {
        try {
            const response = await api.get(API_URLS.HOTELS_SEARCH, { params: queryParams });
            return response.data;
        } catch (error) {
            console.error('Error fetching hotel search results:', error);
            throw error;
        }
    },

    getHotelDetail: async (id, queryParams = {}) => {
        try {
            const response = await api.get(API_URLS.HOTEL_DETAIL(id), { params: queryParams });
            return response.data;
        } catch (error) {
            console.error(`Error fetching hotel ${id}:`, error);
            throw error;
        }
    },

    suggestLocations: async (query) => {
        try {
            const response = await api.get(API_URLS.LOCATION_SUGGEST, { params: { q: query } });
            return response.data;
        } catch (error) {
            console.error('Error fetching autosuggest:', error);
            throw error;
        }
    },

    prebookHotel: async (bookHash) => {
        try {
            const response = await api.post(API_URLS.BOOKING_PREBOOK, { book_hash: bookHash });
            return response.data;
        } catch (error) {
            console.error('Error prebooking hotel room:', error);
            throw error;
        }
    },

    createHotelBooking: async (bookingPayload) => {
        try {
            const response = await api.post(API_URLS.CREATE_HOTEL_BOOKING, bookingPayload);
            return response.data;
        } catch (error) {
            console.error('Error creating hotel booking:', error);
            throw error;
        }
    },

    getBookingStatus: async (orderId) => {
        try {
            const response = await api.get(API_URLS.BOOKING_STATUS(orderId));
            return response.data;
        } catch (error) {
            console.error(`Error checking booking status ${orderId}:`, error);
            throw error;
        }
    },

    // RateHawk Aliases for backward compatibility
    searchRatehawkHotels: async (queryParams = {}) => {
        return propertyService.searchHotels(queryParams);
    },

    getRatehawkHotelDetail: async (id, queryParams = {}) => {
        return propertyService.getHotelDetail(id, queryParams);
    },

    prebookRatehawk: async (bookHash) => {
        return propertyService.prebookHotel(bookHash);
    },

    createRatehawkBooking: async (bookingPayload) => {
        return propertyService.createHotelBooking(bookingPayload);
    },

    getRatehawkBookingStatus: async (orderId) => {
        return propertyService.getBookingStatus(orderId);
    },
};
